const Trainingenum = {
  TrainingMode: {
    ONLINE: "online",
    VIDEO: "Video training",
    OFFLINE: "offline",
  },

  TerminationType: {
    VOLUNTARY_TERMINATION: "Voluntary Termination",
    INVOLUNTARY_TERMINATION: "Involuntary Termination",
    LAYOFF: "Layoff",
    EMPLOYMENT_AT_WILL: "Employment at Will",
    MUTUAL_TERMINATION: "Mutual Termination",
    DISMISSAL: "Dismissal",
    BENEFITS_AFTER_TERMINATION: "Benefits After Termination",
    TERMINATION_FOR_CAUSE: "Termination for Cause",
    WRONGFUL_TERMINATION: "Wrongful Termination",
    GETTING_FIRED: "Getting Fired",
    ILLEGAL_DISMISSALS: "Illegal Dismissals",
    MUTUAL_AGREEMENT: "Mutual Agreement",
    NOTICE_OF_TERMINATION: "Notice of Termination",
    RETIREMENT: "Retirement",
    CONSTRUCTIVE_DISCHARGE: "Constructive Discharge",
    IMMEDIATE_TERMINATION: "Immediate Termination",
    RESIGNATION: "Resignation",
    TERMINATION_UNDER_CONTRACT: "Termination Under Contract",
    FIXED_TERM_CONTRACT_END: "The End of a Fixed-Term Contract",
  },
};

export default Trainingenum;
